import { Controller } from '@hotwired/stimulus';
import {
  hide as hideArticleActions,
  show as showArticleActions,
} from '@controllers/main/article-actions_controller';
import CurrentPage from '@frontend/app/features/CurrentPage';
import debounce from 'lodash.debounce';
import { dispatchCustomEvent } from '@frontend/utils/events';

export default class extends Controller {
  static targets = ['content', 'navbar', 'topbar'];
  static values = {
    navbarIsStickyToTop: { type: Boolean, default: false },
    previousScrollPosition: { type: Number, default: 0 },
    wasScrollingDown: { type: Boolean, default: false },
    topbarHidden: { type: Boolean, default: false },
    articleActionsHidden: { type: Boolean, default: false },
  };

  connect() {
    if (
      !this.hasContentTarget ||
      !this.hasNavbarTarget ||
      !this.hasTopbarTarget
    )
      return false;

    this.navbarIsStickyToTopValue = this.navbarTarget.clientHeight === 0;

    if (CurrentPage.isArticlePreview()) {
      hideArticleActions();
      this.hideTopbar();
      this.hideNavbar();
    } else {
      window.addEventListener('touchstart', debounce(this.handleScrollChange.bind(this), 100));
      window.addEventListener('scroll', debounce(this.handleScrollChange.bind(this), 100));
      this.handleScrollChange();
    }
  }

  handleScrollChange() {
    console.log('handleScrollChange')
    if (this.isScrollPositionInsideArticle()) {
      const isScrollingDown = this.isScrollingDown();
      this.topbarHiddenValue = !this.navbarIsStickyToTopValue && isScrollingDown;
      this.articleActionsHiddenValue = isScrollingDown;
    } else {
      this.topbarHiddenValue = false;
      this.articleActionsHiddenValue = false;
    }

    this.storePreviousScrollPosition();
    dispatchCustomEvent("article-reading-progress:update");
  }

  topbarHiddenValueChanged() {
    if(this.topbarHiddenValue) {
      this.hideTopbar();
    } else {
      this.showTopbar();
    }
  }

  articleActionsHiddenValueChanged() {
    if(this.articleActionsHiddenValue) {
      hideArticleActions();
    } else {
      showArticleActions();
    }
  }

  storePreviousScrollPosition() {
    this.previousScrollPositionValue = this.currentScrollPosition();
  }

  currentScrollPosition() {
    return window.pageYOffset || document.documentElement.scrollTop;
  }

  isScrollPositionInsideArticle() {
    const contentPosFromTop = this.contentTarget.getBoundingClientRect().top;
    const contentHeight = this.contentTarget.clientHeight;
    const halfWindowHeight = window.innerHeight / 2;
    const contentScrolledHalfIntoWindow = contentPosFromTop < halfWindowHeight;
    const contentScrolledNotYetOutOfView = contentPosFromTop - halfWindowHeight + contentHeight > 0;
    const contentInView = contentScrolledHalfIntoWindow && contentScrolledNotYetOutOfView;

    return contentInView;
  }

  isScrollingDown() {
    return this.previousScrollPositionValue < this.currentScrollPosition();
  }

  hideNavbar() {
    this.navbarTarget.classList.add('hidden');
  }

  hideTopbar() {
    if(this.hasTopbarTarget) {
      this.topbarTarget.classList.add('navbar-hidden');
    }
  }

  showTopbar() {
    if(this.hasTopbarTarget) {
      this.topbarTarget.classList.remove('navbar-hidden');
    }
  }
}
